module.exports = __webpack_public_path__ + "img/face-viewfinder.78dedc55.svg";